import { Color, DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SkeletonWrapper = styled.div`
  margin-bottom: ${Spacing.S32};
  border: 1px solid ${Color.Grey200};
  border-radius: ${DefaultValue.BorderRadius};
`
export const SkeletonRow = styled.div`
  display: flex;
  padding: ${Spacing.S16} ${Spacing.S4};
  border-bottom: 1px solid ${Color.Grey200};
`

export const SkeletonCheckboxCell = styled.div`
  width: 72px;
  padding-left: ${Spacing.S24};
`
